import { z } from "zod";
const featureLimitedSchema = z.object({
    max: z.number().optional(),
    errorMessage: z.string(),
    errorReason: z.string(),
});
const featureToggleSchema = z.object({
    enabled: z.boolean(),
    errorMessage: z.string(),
    errorReason: z.string(),
});
const featureWithImportJobsSchema = featureLimitedSchema.extend({
    noImportJobsErrorMessage: z.string(),
    noImportJobsErrorReason: z.string(),
});
export const FeaturesSummary = z.object({
    designSystems: featureLimitedSchema,
    designSystemSources: featureWithImportJobsSchema,
    designSystemStorybookSources: featureLimitedSchema,
    documentationCustomCssAndJs: featureToggleSchema,
    designSystemVersions: featureLimitedSchema,
    themes: featureLimitedSchema,
    brands: featureLimitedSchema,
    codegenSchedules: featureLimitedSchema,
    publicDocumentation: featureToggleSchema,
    customDocumentationUrl: featureToggleSchema,
    customDocumentationViewButton: featureToggleSchema,
    designSystemSourceAutoImport: featureToggleSchema,
    designSystemSlug: featureToggleSchema,
    ipWhitelisting: featureToggleSchema,
    customLogin: featureToggleSchema,
    npmRegistry: featureToggleSchema,
    sso: featureToggleSchema,
    workspacePaidSeats: featureLimitedSchema,
    workspaceViewers: featureLimitedSchema,
    customDocumentationExporter: featureToggleSchema,
    protectedPages: featureToggleSchema,
    approvals: featureToggleSchema,
    selectivePublishing: featureToggleSchema,
    designSystemAccessModes: featureToggleSchema,
    designSystemRoles: featureToggleSchema,
    documentationPageRedirects: featureToggleSchema,
    designSystemAdoption: featureToggleSchema,
    analytics: featureLimitedSchema,
    designSystemFileSize: featureLimitedSchema,
    forgeActiveProjects: featureLimitedSchema,
    forgeProjectFileSize: featureLimitedSchema,
    forgeActiveFeaturesPerProject: featureLimitedSchema,
    forgeActiveDocumentsPerProject: featureLimitedSchema,
    forgePrivateProjects: featureToggleSchema,
    forgeAttachFigmaFrames: featureToggleSchema,
    forgeActiveProjectContexts: featureLimitedSchema,
    contextAdvancedFiltering: featureToggleSchema,
    forgeContextComposition: featureToggleSchema,
    forgeFeatureWorkspacePublishing: featureToggleSchema,
    forgeFeatureHideSupernovaUI: featureToggleSchema,
    documentationPages: featureLimitedSchema,
    pageHistoryRetention: featureLimitedSchema,
    pageHistoryRestore: featureToggleSchema,
    sandboxTemplates: featureToggleSchema,
    forgeShellTemplates: featureLimitedSchema,
    knowledgeSkills: featureLimitedSchema,
});
